const ActivitiesSection = () => {
    return (
        <section className="basic-area activities-area section-animate">
            <div className="container">
                <div className="basic-flex activities">
                    <img
                        className="basic-flex__image"
                        src="/images/activity.gif"
                        alt="Creating a customer feedback survey with Kata Life mobile app"
                    />

                    <div className="basic-flex__content">
                        <h2>
                            Create Your First Survey in Under 2 Minutes
                        </h2>
                        <div>
                            With predefined survey templates and question banks, you can create surveys in minutes. No technical skills required.
                        </div>
                        <br></br>
                        <img
                            style={{
                                width: "600px", height: "300px", alignSelf: "center"
                            }}
                            className="basic-flex__image box-shadow"
                            src="/images/portalCreateActivity.png"
                            alt="Kata Life portal dashboard showing survey creation interface"
                        />
                    </div>


                </div>
            </div>
        </section>
    );
};

export default ActivitiesSection;
